import React, { useState } from "react";
import "./layout.css";
import profile from "../../assets/profile.png";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem"; 
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from  "@mui/icons-material/KeyboardArrowUp";
import { useDispatch } from "react-redux";
import { userLogout } from "../../redux/slices/authSlice";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

const Header = ({name ="Luna"}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [opened, setOpened] = useState(false);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const handleClick = (event) => {
    setOpened(true);
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setOpened(false);
    setAnchorEl(null);
  };
  const location = useLocation()

  const navigate = useNavigate();
  const handleOpen = (path)  => {  navigate(`/${path}`);handleClose() };
  return (
    <div className="bar">
      <div className="d-flex">
        <div className="right">
          <div className="greet">Welcome! {name}</div>
          <div className="dropdown">
             
              <img src={profile} alt="profile" width={"40px"}/>
            
            <div>
              <Button
                id="demo-customized-button"
                aria-controls={open ? "demo-customized-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="text"
                disableElevation
                onClick={handleClick}
                sx={{color:"#000",fontSize:"16px","&:hover":{
                  background:"#fff",boxShadow:"0px !important"
                }}}
                endIcon={!opened ? <KeyboardArrowDownIcon style={{color:"#1E8FCF"}} /> : <KeyboardArrowUpIcon style={{color:"#1E8FCF"}}/>}
              >
                Profile
              </Button>
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <MenuItem selected={location.pathname == "/view_profile"} onClick={() => handleOpen('view_profile')} disableRipple>
                   Profile
                </MenuItem>
                <MenuItem selected={location.pathname == "/change_password"} onClick={() => handleOpen('change_password')} disableRipple>
                   Change Password
                </MenuItem>
                 
                <MenuItem onClick={() => dispatch(userLogout())} disableRipple sx={{color:"#E65555"}}>
                   Logout
                </MenuItem>
                 
              </StyledMenu>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
